








  import { Component, Vue } from 'vue-property-decorator';
  
@Component({
  name:"ListArticles",
  components:{}
})
export default class ListArticles extends Vue {
  private arianeItems = [
    { text: 'Administration', disabled: false, to: {name:'Admin'}, exact:true},
    { text: 'Dashboard', disabled: false, to: {name:'Dashboard'}, exact:true},
    { text: 'Articles',       disabled: true,  to: {name: 'ListArticles'}}
  ]  
}
